'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var button = document.querySelector('.pending-anonymous-payment #cancelPayment');
    if (!button) return;

    button.addEventListener('click', cancelPaymentClick);

    function cancelPaymentClick(event) {
        var ajaxHelper = new _ajaxHelper2.default();
        ajaxHelper.sendRequest('/Payment/CancelAnonymousPendingPaymentAndOrder', cancelPaymentClickDone);
    }

    function cancelPaymentClickDone(httpRequest, responseObject) {
        if (responseObject.result.type === 0) {
            abp.notify.success(Resx.Messages.ManualPaymentCancelSuccessful);

            setTimeout(function () {
                window.location.href = '/';
            }, 1000);
        } else {
            abp.notify.error(responseObject.result.message);
        }
    }
};

var _ajaxHelper = require('../libraries/ajaxHelper');

var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/cartPendingPayment.js
// module id = 1059
// module chunks = 1